import React from 'react';

export default function LoadingVideo({ text = "Memuat data..." }) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="w-32 h-32 md:w-48 md:h-48 border-4 border-foreground bg-white shadow-brutal-lg overflow-hidden mb-6">
        <video 
          src="/loading.mp4" 
          autoPlay 
          loop 
          muted 
          playsInline
          className="w-full h-full object-cover"
        />
      </div>
      <p className="font-display text-xl font-bold uppercase tracking-widest animate-pulse">
        {text}
      </p>
    </div>
  );
}
